import { render, staticRenderFns } from "./UsageTab.vue?vue&type=template&id=0be4f717"
import script from "./UsageTab.vue?vue&type=script&lang=js"
export * from "./UsageTab.vue?vue&type=script&lang=js"
import style0 from "./UsageTab.vue?vue&type=style&index=0&id=0be4f717&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports